module.exports = __webpack_public_path__ + "media/signup-react/pinchme_logo-16195215.svg";